import React from "react";
import {Route, Switch} from "react-router-dom";
import NotFound from "./containers/NotFound";
import Login from "./containers/Login";
import Dashboard from "./containers/Dashboard";
import Build from "./containers/Build";
import Logs from "./containers/Logs";
import AppliedRoute from "./components/AppliedRoute";
import Signup from "./containers/Signup";
import AccountManagement from "./containers/AccountManagement";
import DeviceManagement from "./containers/DeviceManagement";

export default ({childProps}) =>
    <Switch>
        {
            !childProps.isAuthenticated ?
                <AppliedRoute path="/" exact component={Login} props={childProps}/>
            :   <AppliedRoute path="/" exact component={Logs} props={childProps}/>
        }
        <AppliedRoute path="/login" exact component={Login} props={childProps}/>
        <AppliedRoute path="/dashboard" exact component={Dashboard} props={childProps}/>
        <AppliedRoute path="/logs" exact component={Logs} props={childProps}/>
        <AppliedRoute path="/deviceManagement" exact component={DeviceManagement} props={childProps}/>
        <AppliedRoute path="/build" exact component={Build} props={childProps}/>
        <AppliedRoute path="/accounts" exact component={AccountManagement} props={childProps}/>
        <AppliedRoute path="/signup" exact component={Signup} props={childProps}/>
        { /* Finally, catch all unmatched routes */}
        <Route component={NotFound}/>
    </Switch>;
